import * as actionTypes from '../types/inputReadyProducts';

const initialState = {
  inputPieces: [],
  plantOperationAttribsInheritDtos: [],
  length: 0,
  mark: '' || null,
  normativeDoc: '' || null,
  operationNumId: 0 || null,
  operationType: 0 || null,
  pieceId: '' || null,
  pieceNumId: 0 || null,
  profileSize: '' || null,
  qcDate: '' || null,
  qcId: 0 || null,
  qty: 0 || null,
  quantity: 0 || null,
  quantityOff: 0,
  unitOfMeasure: '' || null,
  unitShort: '' || null,
  productUnit: '' || null,
  thickness: 0 || null,
  zdvlLineId: 0 || null,
  zdvlLineNumId: 0 || null,
  taskNumId: 0 || null,
  error: false,
  loading: false,
  okRequest: false,
  okRequestModal: false,
  okUpdateRequest: false,
  loadingModal: false
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.INPUT_READY_PRODUCTS:
      return {
        ...state,
        okRequest: false,
        loading: true
      };
    case actionTypes.INPUT_READY_PRODUCTS_SUCCESS:
      return {
        ...state,
        length: payload.length,
        mark: payload.mark,
        normativeDoc: payload.normativeDoc,
        operationNumId: payload.operationNumId,
        operationType: payload.operationType,
        pieceId: payload.pieceId,
        pieceNumId: payload.pieceNumId,
        profileSize: payload.profileSize,
        qcDate: payload.qcDate,
        qcId: payload.qcId,
        qty: payload.qty,
        thickness: payload.thickness,
        zdvlLineId: payload.zdvlLineId,
        taskNumId: payload.taskNumId,
        zdvlLineNumId: payload.zdvlLineNumId,
        inputPieces: payload.inputPieces.map((item) => ({
          ...item,
          // eslint-disable-next-line no-restricted-globals
          percentWasteMaterial: isNaN(item.percentWasteMaterial) || item.percentWasteMaterial === 'NaN'
            ? 0 : item.percentWasteMaterial
        })),
        plantOperationAttribsInheritDtos: payload.plantOperationAttribsInheritDtos,
        quantity: payload.quantity,
        quantityOff: payload.quantityOff || 0,
        unitOfMeasure: payload.unitOfMeasure,
        unitShort: payload.unitShort,
        productUnit: payload.unitShort,
        okRequest: true,
        loading: false
      };
    case actionTypes.INPUT_READY_PRODUCTS_FAIL:
      return {
        ...state,
        okRequest: false,
        loading: false
      };
    case actionTypes.SET_NORMATIVE_DOC:
      return {
        ...state,
        normativeDoc: payload
      };
    case actionTypes.SET_MARK:
      return {
        ...state,
        mark: payload
      };
    case actionTypes.SET_LENGTH:
      return {
        ...state,
        length: payload
      };
    case actionTypes.SET_OPERATION_NUM_ID:
      return {
        ...state,
        operationNumId: payload
      };
    case actionTypes.SET_OPERATION_TYPE:
      return {
        ...state,
        operationType: payload
      };
    case actionTypes.SET_PROFILE_SIZE:
      return {
        ...state,
        profileSize: payload
      };
    case actionTypes.SET_PIECE_ID:
      return {
        ...state,
        pieceId: payload
      };
    case actionTypes.SET_PIECE_NUM_ID:
      return {
        ...state,
        pieceNumId: payload
      };
    case actionTypes.SET_ZDVL_LINE_ID:
      return {
        ...state,
        zdvlLineId: payload
      };
    case actionTypes.SET_ZDVL_LINE_NUM_ID:
      return {
        ...state,
        zdvlLineNumId: payload
      };
    case actionTypes.SET_QC_DATE:
      return {
        ...state,
        qcDate: payload
      };
    case actionTypes.SET_QC_ID:
      return {
        ...state,
        qcId: payload
      };
    case actionTypes.SET_QTY:
      return {
        ...state,
        qty: payload
      };
    case actionTypes.SET_THICKNESS:
      return {
        ...state,
        thickness: payload
      };
    case actionTypes.SET_QUANTITY:
      return {
        ...state,
        quantity: payload
      };
    case actionTypes.SET_QUANTITY_OFF:
      return {
        ...state,
        quantityOff: payload
      };
    case actionTypes.SET_READY_UNIT:
      return {
        ...state,
        productUnit: payload
      };
    case actionTypes.UPDATE_READY_PRODUCTS:
      return {
        ...state,
        okUpdateRequest: false,
        loading: true
      };
    case actionTypes.UPDATE_READY_PRODUCTS_SUCCESS:
      return {
        ...state,
        okUpdateRequest: true,
        loading: false
      };
    case actionTypes.UPDATE_READY_PRODUCTS_FAIL:
      return {
        ...state,
        okUpdateRequest: false,
        loading: false
      };
    case actionTypes.ADD_INPUT_PIECE:
      return {
        ...state,
        inputPieces: Array.from(
          new Set([...state.inputPieces, ...payload].map(JSON.stringify))
        ).map(JSON.parse)
      };
    case actionTypes.SET_INPUT_PRODUCTS_PIECES:
      return {
        ...state,
        inputPieces: payload
      };
    case actionTypes.SET_READY_ATTRIBS_INHERIT:
      return {
        ...state,
        plantOperationAttribsInheritDtos: payload
      };
    default:
      return state;
  }
};

export default reducer;
